<template>
  <el-switch
    :value="value"
    :active-color="activeColor"
    :inactive-color="inactiveColor"
    :disabled="disabled"
    @change="$emit('change', value)"
  >
  </el-switch>
</template>

<script>
export default {
  name: 'Switch',
  props: {
    activeColor: {
      type: String,
      default: '#13ce66'
    },
    inactiveColor: {
      type: String,
      default: '#ff4949'
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // eslint-disable-next-line vue/no-dupe-keys
      value: true
    };
  }
};
</script>

<style lang="scss" scoped></style>
